import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EstimateDetailsModal } from './Modal_Estimate_Details';

//import classes from './Modal_ViewModal.module.css';
import '../../../css/layout.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewEstimateListModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [viewEstimates, setViewEstimates] = useState([]);

    let [estimateID, setEstimateID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [showEstimateDetailsModal, setShowEstimateDetailsModal] = useState(false);

    useEffect(() => {


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_estimate_list',
                    user: acctID,
                    xStartDateRange: props.startDate.toISOString().substr(0, 10),
                    xEndDateRange: props.endDate.toISOString().substr(0, 10),
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewEstimates((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            estimateID: cols[0],
                            customerID: cols[1],
                            customerFirstName: cols[2],
                            customerLastName: cols[3],
                            customerMobileNumber: cols[4],
                            estimateDescription: cols[5],
                            estimateLatitude: cols[6],
                            estimateLongitude: cols[7],
                            dateLogged: cols[8],
                            estimateImage1: cols[9],
                            status: cols[10],
                            externalID: cols[11],
                        })
                    });
                } 
            })
        
    }, []);

    function deleteEstimate(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002D');
        formData.append('user', acctID);
        formData.append('xEstimateID', estimateID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002D',
                user: acctID,
                xEstimateID: estimateID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewEstimates([]);
        props.closeModal(event);
    }
 
    function viewEstimateDetailsHandler(event) {


        setEstimateID(event[1]);
        setShowEstimateDetailsModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteEstimateHandler(event) {


        //setShowPasswordModal(event[0]);
        setEstimateID(event);
    }

    function onSubmitPasswordHandler(event)
    {
        deleteEstimate(event);
    }



    return (

        <React.Fragment> 
            {props.openModal == true ?
            (
                <IonModal isOpen={ props.openModal }>
                    <IonHeader style={{color: 'black'}}>
                        <h3> One-Time Estimates </h3>
                    </IonHeader>

                    <IonContent className='grid_content'>
                        <IonGrid >
                            <IonRow >
                                    <IonCol size='4'> <h3> Customer Name </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Estimate Description </h3> </IonCol>*/}
                                    <IonCol size='4'> <h3> Date Logged </h3> </IonCol>
                                    <IonCol size='4'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewEstimates.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.estimateID}>
                                        <IonCol size='4'>{detailData.customerFirstName} {detailData.customerLastName}</IonCol>
                                        {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='4'>{detailData.dateLogged}</IonCol>
                                        <IonCol size='4'>

                                            <IonButton onClick={() => viewEstimateDetailsHandler([true, detailData.estimateID])}> Details </IonButton>
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteEstimateHandler(detailData.estimateID)}> Delete </IonButton>}
                                            {/*<IonButton class='gridResultColumnButton' onClick={() => setViewAttachemntModal(true)}> View Invoice</IonButton>*/}
                                    
                                        </IonCol>


                                        {showEstimateDetailsModal == true && <EstimateDetailsModal openModal={ showEstimateDetailsModal } closeModal={() => setShowEstimateDetailsModal(false)} data={{
                                            estimateID: detailData.estimateID, 
                                            customerID: detailData.customerID, 
                                            externalID: detailData.externalID,
                                            }}></EstimateDetailsModal>}
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>

                    </IonContent>

                    <IonFooter className='grid_footer'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                </IonModal>            
            ) : null }

        </React.Fragment>

    )
}